import { render } from "./UserManagementTable.vue?vue&type=template&id=66e368b9&scoped=true"
import script from "./UserManagementTable.vue?vue&type=script&lang=js"
export * from "./UserManagementTable.vue?vue&type=script&lang=js"

import "./UserManagementTable.vue?vue&type=style&index=0&id=66e368b9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e368b9"]])

export default __exports__